import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'dark-footer-cta' }>

export default function DarkFooterCTA(block: BlockProps): ReactElement {
  const { title, buttons, options } = block
  const variant = options?.variant ?? 'black'

  return (
    <Container>
      <div
        className={cn(`relative p-8 md:p-12 lg:p-20 flex flex-col justify-center items-center`, {
          'bg-black': variant === 'black',
          'bg-telesoft': variant === 'blue',
        })}
      >
        <Grid className="w-full">
          <div className="col-span-full">
            <Text
              variant="pageHeading"
              className={cn({
                'text-white': variant === 'black',
                'text-black': variant === 'blue',
              })}
            >
              {title}
            </Text>
          </div>

          {buttons &&
            buttons.map(btn => {
              return (
                <CMSLink
                  key={btn.id}
                  {...btn.link}
                  variant={variant === 'black' ? 'default' : 'outline'}
                  className={cn('col-span-4 lg:col-span-6', {
                    'text-white': variant === 'black',
                  })}
                />
              )
            })}
        </Grid>
      </div>
    </Container>
  )
}
